import { render, staticRenderFns } from "./layTimeArchive.vue?vue&type=template&id=31453017"
import script from "./layTimeArchive.vue?vue&type=script&lang=js"
export * from "./layTimeArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports